module.exports = __webpack_public_path__ + "assets/img/1.fa7f921c.jpg";